webpackJsonp([15],{

/***/ "+aT9":
/***/ (function(module, exports) {

module.exports = AMap;

/***/ }),

/***/ "IcnI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var actions_namespaceObject = {};

// EXTERNAL MODULE: ./node_modules/._vue@2.5.16@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("4FMX");

// EXTERNAL MODULE: ./node_modules/._vuex@3.0.1@vuex/dist/vuex.esm.js
var vuex_esm = __webpack_require__("dXqY");

// CONCATENATED MODULE: ./src/store/mutation-types.js
var CHANGEFROMURL = 'CHANGEFROMURL';
var RECORD_USERINFO = 'RECORD_USERINFO';
// CONCATENATED MODULE: ./src/store/actions.js


// import {
// 	getUser	
// } from '../service/getData'


// export default {
// 	async getUserInfo({
// 		commit,
// 		state
// 	}) {
// 		let res = await getUser();
// 		commit(GET_USERINFO, res)
// 	},
// 	async recordUserInfo({
// 		commit,
// 		state
// 	}) {
// 		let res = await getUser();
// 		commit(RECORD_USERINFO, res)
// 	},
// }


// export const addToCart = ({ commit }, text) => { 
//    commit(types.ADD_TO_CART, text)
//   }
// EXTERNAL MODULE: ./src/store/getters.js
var getters = __webpack_require__("UjVw");
var getters_default = /*#__PURE__*/__webpack_require__.n(getters);

// EXTERNAL MODULE: ./node_modules/._babel-runtime@6.26.0@babel-runtime/helpers/defineProperty.js
var defineProperty = __webpack_require__("hNT/");
var defineProperty_default = /*#__PURE__*/__webpack_require__.n(defineProperty);

// EXTERNAL MODULE: ./src/util/util.js
var util = __webpack_require__("yt7g");

// CONCATENATED MODULE: ./src/store/mutations.js


var _CHANGEFROMURL$RECORD;







/* harmony default export */ var mutations = (_CHANGEFROMURL$RECORD = {}, defineProperty_default()(_CHANGEFROMURL$RECORD, CHANGEFROMURL, function (state, info) {
  state.fromurl = info;
  state.login = true;
}), defineProperty_default()(_CHANGEFROMURL$RECORD, RECORD_USERINFO, function (state, info) {}), _CHANGEFROMURL$RECORD);
// CONCATENATED MODULE: ./src/store/index.js






vue_esm["default"].use(vuex_esm["a" /* default */]);

var debug = "production" !== 'production';

var state = {
  userInfo: {},
  login: false
};

/* harmony default export */ var store = __webpack_exports__["a"] = (new vuex_esm["a" /* default */].Store({
  actions: actions_namespaceObject,
  getters: getters,
  state: state,
  mutations: mutations,
  strict: debug
}));

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./node_modules/._vue@2.5.16@vue/dist/vue.esm.js
var vue_esm = __webpack_require__("4FMX");

// EXTERNAL MODULE: ./src/util/util.js
var util = __webpack_require__("yt7g");

// CONCATENATED MODULE: ./node_modules/._babel-loader@7.1.4@babel-loader/lib!./node_modules/._vue-loader@13.7.2@vue-loader/lib/selector.js?type=script&index=0!./src/App.vue
//
//
//
//
//
//
//
//




/* harmony default export */ var App = ({
	data: function data() {
		return {
			defaultFontSize: ""
		};
	},
	created: function created() {
		var _this = this;

		this.defaultFontSize = Object(util["c" /* defaultFontSize */])();
		Object(util["a" /* adoptdevice */])(750, 100, this.defaultFontSize);
		window.addEventListener("resize", function () {
			setTimeout(function () {
				Object(util["a" /* adoptdevice */])(750, 100, _this.defaultFontSize);
			}, 200);
		});
	},
	mounted: function mounted() {}
});
// CONCATENATED MODULE: ./node_modules/._vue-loader@13.7.2@vue-loader/lib/template-compiler?{"id":"data-v-5fbf6488","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/._vue-loader@13.7.2@vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
var App_render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: App_render, staticRenderFns: staticRenderFns }
/* harmony default export */ var selectortype_template_index_0_src_App = (esExports);
// CONCATENATED MODULE: ./src/App.vue
function injectStyle (ssrContext) {
  __webpack_require__("fAkl")
}
var normalizeComponent = __webpack_require__("E9e/")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5fbf6488"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  App,
  selectortype_template_index_0_src_App,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var src_App = (Component.exports);

// EXTERNAL MODULE: ./node_modules/._axios@0.17.1@axios/index.js
var __axios_0_17_1_axios = __webpack_require__("iXuc");
var __axios_0_17_1_axios_default = /*#__PURE__*/__webpack_require__.n(__axios_0_17_1_axios);

// EXTERNAL MODULE: ./src/router/index.js
var router = __webpack_require__("YaEn");

// EXTERNAL MODULE: ./src/store/index.js + 3 modules
var store = __webpack_require__("IcnI");

// EXTERNAL MODULE: ./node_modules/._mint-ui@2.2.13@mint-ui/lib/mint-ui.common.js
var mint_ui_common = __webpack_require__("Wh0R");
var mint_ui_common_default = /*#__PURE__*/__webpack_require__.n(mint_ui_common);

// EXTERNAL MODULE: ./node_modules/._mint-ui@2.2.13@mint-ui/lib/style.css
var style = __webpack_require__("Rxme");
var style_default = /*#__PURE__*/__webpack_require__.n(style);

// EXTERNAL MODULE: ./src/css/reset.css
var css_reset = __webpack_require__("xsZ7");
var reset_default = /*#__PURE__*/__webpack_require__.n(css_reset);

// EXTERNAL MODULE: ./node_modules/._vue-baidu-map@0.21.22@vue-baidu-map/index.js
var __vue_baidu_map_0_21_22_vue_baidu_map = __webpack_require__("ybSp");
var __vue_baidu_map_0_21_22_vue_baidu_map_default = /*#__PURE__*/__webpack_require__.n(__vue_baidu_map_0_21_22_vue_baidu_map);

// CONCATENATED MODULE: ./src/main.js
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bus", function() { return bus; });

// import {createGDMap} from '@/util/util.js'
// createGDMap();
// import AMap from 'vue-amap';
// console.log(AMap)
// Vue.use(AMap);








vue_esm["default"].use(mint_ui_common_default.a);




vue_esm["default"].use(__vue_baidu_map_0_21_22_vue_baidu_map_default.a, {
  // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
  ak: 'yHVt3rkXPnQDQW51WVrdyljYkoMWvNdL'
});
vue_esm["default"].config.productionTip = false;

var vm = new vue_esm["default"]({
  el: '#app',
  router: router["a" /* default */],
  store: store["a" /* default */],
  template: '<App/>',
  components: { App: src_App },
  render: function render(h) {
    return h(src_App);
  }
});

vue_esm["default"].directive('focus', {
  inserted: function inserted(el) {
    el.focus();
  }
});

var bus = new vue_esm["default"]();

/***/ }),

/***/ "Rxme":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "UjVw":
/***/ (function(module, exports) {

// export const cartProducts = state => {
//   return state.cart.added.map(({ id, quantity }) => {
//     const product = state.products.all.find(p => p.id === id)
//     return {
//       title: product.producttitle,
//       price: product.price,
//       img:product.imgsmall,
//       quantity
//     }
//   })
// }

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("4FMX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("byqf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__util_util__ = __webpack_require__("yt7g");



// import store from "../store"

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  // hashbang: true,
  routes: [{
    path: '/',
    redirect: '/home'
  }, {
    path: '/auth',
    name: '欢迎使用移动能源交易平台',
    // redirect: '/home',
    component: function component(resolve) {
      return __webpack_require__.e/* require */(4).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("Qx61")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/home',
    name: '欢迎使用移动能源交易平台',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(3)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("nU8l")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/equipconfirm',
    name: ' 充电桩详情',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(8)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("TnJo")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/choosetype',
    name: '欢迎使用移动能源交易平台',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(7)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("q/8J")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/charging/:id',
    name: '充电中',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(11)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("AO2p")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/rent',
    name: ' 激活充电包',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(2)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("ecb2")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/rentcharging/:id',
    name: '充电包详情',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(12)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("yY1e")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/rentequips',
    name: '移动能源租用设备',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(10)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("enQC")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/rentequipsdetail/:id',
    name: '移动能源租用设备 ',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(6)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("VAy+")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }, {
    path: '/usercenter',
    redirect: '/usercenter/charge',
    name: '我的充电设备',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(13)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("drXp")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    },
    children: [{
      path: '/usercenter/charge',
      name: '个人中心',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(5)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("IxWE")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }, {
      path: '/usercenter/rent',
      name: '我的租用设备',
      component: function component(resolve) {
        return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(9)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("SksO")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
      }
    }]
  }, {
    path: '/service',
    name: '应急充电',
    component: function component(resolve) {
      return Promise.all/* require */([__webpack_require__.e(0), __webpack_require__.e(1)]).then(function() { var __WEBPACK_AMD_REQUIRE_ARRAY__ = [__webpack_require__("iHYi")]; ((resolve).apply(null, __WEBPACK_AMD_REQUIRE_ARRAY__));}.bind(this)).catch(__webpack_require__.oe);
    }
  }]
});
/* harmony default export */ __webpack_exports__["a"] = (router);

router.beforeEach(function (to, from, next) {
  if (to.path == '/auth' && Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["f" /* getCookie */])('token')) {
    console.log('secondIn');
    // 用户使用后退返回到授权页，则默认回到首页
    next({ path: '/home' });
    return false;
  }
  console.log(Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["f" /* getCookie */])('token'), to.path);
  console.log(!to.path != '/auth');
  if (!Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["f" /* getCookie */])('token') && to.path != '/auth') {
    // 第一次进入项目
    console.log('fisrtIn');
    if (to.path != '/home') {
      // alert(to.fullPath)
      Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["h" /* setCookie */])('beforeLoginUrl', to.fullPath); // 保存用户进入的url
    }
    next({ path: '/auth' });
    return false;
  }
  next();
});

router.afterEach(function (to, from, next) {
  console.log('\u6210\u529F\u6D4F\u89C8\u5230: ' + to.path);
  // console.log(from);
  if (from.fullPath.indexOf('charging') != -1 || from.fullPath.indexOf('rentcharging') != -1) {
    Object(__WEBPACK_IMPORTED_MODULE_2__util_util__["b" /* clearAlltimer */])();
  }
  document.title = to.name;
  window.scrollTo(0, 0);
});

/***/ }),

/***/ "fAkl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "n+06":
/***/ (function(module, exports) {

module.exports = AMapUI;

/***/ }),

/***/ "xsZ7":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yt7g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return defaultFontSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return adoptdevice; });
/* unused harmony export isOver720 */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return parseQuery; });
/* unused harmony export isUserCookie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return setCookie; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return delCookie; });
/* unused harmony export delAllcookie */
/* unused harmony export formatmoney */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formatDate; });
/* unused harmony export createGDMap */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return clearAlltimer; });
/* unused harmony export doAuthReady */
/* unused harmony export wxShareConfig */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("Hcuw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__("IcnI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");


var _this = this;




var defaultFontSize = function defaultFontSize() {
  var d = window.document.createElement('div');
  d.style.width = '1rem';
  d.style.display = "none";
  var head = window.document.getElementsByTagName('head')[0];
  head.appendChild(d);
  var defaultFontSize = parseFloat(window.getComputedStyle(d, null).getPropertyValue('width'));
  d.remove();
  return defaultFontSize;
};

var adoptdevice = function adoptdevice(designWidth, rem2px, defaultFontSize) {
  var head = window.document.getElementsByTagName('head')[0];
  document.documentElement.style.fontSize = window.innerWidth / designWidth * rem2px / defaultFontSize * 100 + '%';
  var x = window.innerWidth / designWidth * rem2px / defaultFontSize * 100 + '%';
  var st = document.createElement('style');
  var portrait = "@media screen and (min-width: " + window.innerWidth + "px) {html{font-size:" + x + "}}";
  // var landscape = "@media screen and (min-width: "+window.innerHeight+"px) {html{font-size:"+ ((window.innerHeight/(designWidth/rem2px)/defaultFontSize)*100) +"%;}}"
  st.innerHTML = portrait;
  head.appendChild(st);
};

var isOver720 = function isOver720() {
  function getInnerWidth() {
    var width = window.innerWidth;
    if (width >= 720) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('OVER720', true);
    } else {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].commit('OVER720', false);
    }
  }
  getInnerWidth();
  window.onresize = function () {
    getInnerWidth();
  };
};

//解析URL参数
var parseQuery = function parseQuery(query) {
  if (query.indexOf('?') != -1) {
    var searchList = query.split('?');
    console.log(searchList);
    var arr = [];
    if (query.indexOf('?#') != -1 && searchList.length > 2) {
      var tokenArr = searchList.find(function (item, index) {
        return item.indexOf('token') > -1;
      });
      console.log(tokenArr);
      arr = tokenArr.split('&');
      //   arr=searchList[2].split('&');
      // }else{
      //   console.log('?')
      //   arr=searchList[1].split('&');
    }
    console.log(arr);
    var result = {}; //声明变量为对象，加{}
    for (var i = arr.length - 1; i >= 0; i--) {
      var arr2 = arr[i].split('=');
      result[arr2[0]] = arr2[1];
    }
    console.error(result);
    return result;
  }
};

//判断是否有缓存
var isUserCookie = function isUserCookie(cookieuserid, path) {
  // let cookieuserid = getCookie('ZDGZUSERID');
  if (cookieuserid === undefined || cookieuserid == null || cookieuserid == "" || cookieuserid == 'undefined') {
    console.log('isUserCookie==false');
    var now = new Date();
    now.setTime(now.getTime() + 10 * 60 * 1000); //记录十分钟的路径cookie
    // if (path.indexOf('#')!= -1 ) {
    //   var currentPath = '#'+path.split('#')[1];
    // }
    console.log('currentPath' + path);
    document.cookie = "pathInfo=" + path + ";expires=" + now.toGMTString();
    __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */].push({ path: '/oauth' });
  }
};

// 读取cookie
var getCookie = function getCookie(c_name) {
  if (document.cookie.length > 0) {
    var c_start = document.cookie.indexOf(c_name + "=");
    if (c_start != -1) {
      c_start = c_start + c_name.length + 1;
      var c_end = document.cookie.indexOf(";", c_start);
      if (c_end == -1) c_end = document.cookie.length;
      return document.cookie.substring(c_start, c_end);
    }
  }
  return "";
};

//正则读取cookie
// function getCookie(name)
// {          //匹配字段
//     var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");

//     if(arr=document.cookie.match(reg))

//         return (arr[2]);
//     else
//         return null;
// }


// 设置cookie
var setCookie = function setCookie(name, info) {
  var validity = 0.1;
  var now = new Date();
  now.setTime(now.getTime() + validity * 24 * 60 * 60 * 1000);
  document.cookie = name + "=" + info + ";expires=" + now.toGMTString();
};

// 删除cookie
var delCookie = function delCookie(name) {
  var exp = new Date();
  exp.setTime(exp.getTime() - 1);
  var cval = getCookie(name);
  if (cval != null) {
    document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString();
  }
};

// 删除所有cookie
var delAllcookie = function delAllcookie(name) {
  console.log("删除缓存");
  var strCookie = document.cookie;
  var arrCookie = strCookie.split("; ");
  for (var i = 0; i < arrCookie.length; i++) {
    var arr = arrCookie[i].split("=");
    if (arr.length > 0)
      // 删除单个cookie方法
      var exp = new Date();
    exp.setTime(exp.getTime() - 1);
    var cval = getCookie(arr[0]);
    if (cval != null) {
      document.cookie = arr[0] + "=" + cval + ";expires=" + exp.toGMTString();
    }
  }
};

//金钱分段，
var formatmoney = function formatmoney(moneystr) {
  // console.log(moneystr)
  moneystr = moneystr.split("");
  moneystr.reverse();
  for (var i = 0; i < moneystr.length; i = i + 4) {
    moneystr.splice(i, 0, ",");
  }
  moneystr = moneystr.slice(1);
  moneystr.reverse();
  moneystr = moneystr.join("");
  return moneystr;
};
// 日期格式化
var formatDate = function formatDate(date, pattern) {
  // console.log(date,pattern)
  var date = new Date(date);
  function format(m) {
    var n = m + 1;
    if (n < 10) {
      return "0" + n;
    } else {
      return n;
    }
  }
  var year = date.getFullYear(),
      month = format(date.getMonth()),
      day = format(date.getDate() - 1),
      hour = format(date.getHours() - 1),
      minute = format(date.getMinutes() - 1),
      second = format(date.getSeconds() - 1);
  switch (pattern) {
    case "yyyy":
      return year;
      break;
    case "yyyy-MM":
      return year + " - " + month;
      break;
    case "yyyy/MM":
      return year + " / " + month;
      break;
    case "yyyy-MM-dd":
      return year + "-" + month + "-" + day;
      break;
    case "yyyy/MM/dd":
      return year + "/" + month + "/" + day;
      break;
    case "yyyy-MM-dd HH":
      return year + "-" + month + "-" + day + " " + hour;
      break;
    case "yyyy/MM/dd HH":
      return year + "/" + month + "/" + day + " " + hour;
      break;
    case "yyyy-MM-dd HH:mm":
      return year + "-" + month + "-" + day + " " + hour + ":" + minute;
      break;
    case "yyyy/MM/dd HH:mm":
      return year + "/" + month + "/" + day + " " + hour + ":" + minute;
      break;
    case "yyyy-MM-dd HH:mm:ss":
      return year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second;
      break;
    case "yyyy/MM/dd HH:mm:ss":
      return year + "/" + month + "/" + day + " " + hour + ":" + minute + ":" + second;
      break;
  }
};
var createGDMap = function createGDMap() {
  console.log("createGDMap function in util");
  // 创建高德地图
  var createMap = function createMap() {
    var promise = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var script = document.createElement('script');
      script.type = 'text/javascript';
      script.src = 'https://webapi.amap.com/maps?v=1.3&key=1f648c12a2709a14b0e79551fdc5f791'; // 高德地图
      document.body.appendChild(script);
      if (script.nodeName === 'SCRIPT') {
        resolve();
      } else {
        reject(new Error('Could not script image at ' + script.src));
      }
    });
    return promise;
  };
  createMap().then(function () {
    console.log('读取高德地图成功');
    // 加載當前的ip定位
  }).catch(function (error) {
    // 处理 getJSON 和 前一个回调函数运行时发生的错误
    console.log('发生错误！', error);
  });
};

var clearAlltimer = function clearAlltimer() {
  var end = setTimeout(function () {}, 1);
  // var start = (end -100)>0?end-100:0;
  for (var i = 0; i <= end; i++) {
    clearTimeout(i);
  }
  console.log("清除所有定时器" + end);
};

// 微信授权
var doAuthReady = function doAuthReady(vm, cb) {
  var code = Utils.getQueryString('code');
  var user = Utils.STORE.getStore(Utils.STORE.user);
  console.log('openid: ' + user.openid);
  // 如果本地存在 openid
  if (user.openid) {
    // 检查服务器有无更新
    _this.checkService(user.openid, function (isExist) {
      if (isExist) {
        this.copyUser(vm, user, cb);
      } else {
        Utils.STORE.setStore(Utils.STORE.user, {});
        this.checkAuth();
      }
    }.bind(_this));
  } else if (code) {
    // 授权回来拿到 code 去后台获取用户信息
    _this.getUserInfo(code).then(function (res) {
      var resUser = res.data.extraInfo;
      this.copyUser(vm, resUser, cb);
      Utils.STORE.setStore(Utils.STORE.user, resUser);
    }.bind(_this));
  } else {
    // 去授权
    _this.checkAuth();
  }
};

// 微信分享配置
var wxShareConfig = function wxShareConfig(title, desc, link, imgUrl) {
  // console.log('wxShare Config')
  wx.ready(function () {
    // “分享给朋友”
    wx.onMenuShareAppMessage({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function success() {},
      fail: function fail(res) {
        console.log(res);
      }
    });
    // “分享到朋友圈”
    wx.onMenuShareTimeline({
      title: title,
      link: link,
      imgUrl: imgUrl,
      success: function success() {},
      fail: function fail(res) {
        console.log(res);
      }
    });

    // 分享到QQ
    wx.onMenuShareQQ({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function success() {},
      fail: function fail(res) {
        console.log(res);
      }
    });
    // 分享到腾讯微博
    wx.onMenuShareWeibo({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function success() {},
      fail: function fail(res) {
        console.log(res);
      }
    });
    // 分享到QQ空间
    wx.onMenuShareQZone({
      title: title,
      desc: desc,
      link: link,
      imgUrl: imgUrl,
      success: function success() {},
      fail: function fail(res) {
        console.log(res);
      }
    });
  });
};

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.fb5c36884a871a3f1e88.js